import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { LocalStorageService, UtilService } from "library";
import { RequestService } from "projects/store/src/app/services/api/v1/request.service";
import { LocalStorageKey, ExternalSite, PhonePlatform, CountryCode } from "projects/store/src/app/enums";
import { environment } from "projects/store/src/environments/environment";

@Component({
  selector: 'app-sales-phone-app-instalation',
  templateUrl: './sales-phone-app-instalation.component.html',
  styleUrls: ['./sales-phone-app-instalation.component.scss']
})
export class SalesPhoneAppInstalationComponent implements OnInit {
  requestId: string;
  person!: any;
  creditData: any;
  contractNumber!: string;
  categoryCode: string;
  routesBreadcrumb = ['VENTAS', 'Autogestión', 'Registro de la aplicación'];
  request: any;
  platform: string = '';
  trustonicAppUrl: string = '';
  readonly PhonePlatform = PhonePlatform;
  @Output() nextStepEvent = new EventEmitter();

  constructor(
    private requestService: RequestService,
    private route: ActivatedRoute,
    private utilService: UtilService,
    private localStorageService: LocalStorageService
  ) {
    this.requestId = this.route.snapshot.params['request_id'];
    this.categoryCode = this.route.snapshot.params['category_code'];
    this.request = this.requestService.request;
  }

  ngOnInit() {
    const data = this.localStorageService.get(LocalStorageKey.salesData);
    if (data?.external_site == ExternalSite['luki-app']) {
      this.onNextStep();
    } else {
      this.load();
    }
  }

  load() {
    this.utilService.enablePageLoading();
    this.loadRequest();
    this.utilService.disablePageLoading();
  }

  loadRequest() {
    this.person = { ...this.request.person };
    this.contractNumber = this.request.number;
    this.creditData = this.request;
    if (environment.global.country.code === CountryCode.CO) {
      this.creditData.agreement.otp = '0000';
    }
    this.platform = this.request.phone_platform || '';
    this.trustonicAppUrl = this.request.app_download_url || '';
  }

  get platformType(): PhonePlatform | '' {
    if (!this.platform) return '';
    const p = this.platform.toLowerCase() as PhonePlatform;
    return Object.values(PhonePlatform).includes(p) ? p : '';
  }

  onNextStep() {
    this.nextStepEvent.emit();
  }
}
